import { get, post } from "aws-amplify/api";
import { getUrl, remove } from "aws-amplify/storage";
import { fetchAuthSession } from "aws-amplify/auth";

export default class HttpRequest {
  static async addQueryParameters(queryParams, page, limit, searchTerm) {
    if (page !== undefined && limit !== undefined) {
      queryParams.page = String(page);
      queryParams.limit = String(limit);
    }
    if (searchTerm) {
      queryParams.q = searchTerm;
    }
    return queryParams;
  }

  static async getHash(id) {
    const session = await fetchAuthSession();
    const identityId = session.identityId;
    let hashData = `${id}${identityId}`;

    // Use Web Crypto API instead of Node.js crypto
    const encoder = new TextEncoder();
    const data = encoder.encode(hashData);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hash = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");

    return hash;
  }

  static async fetchDocumentsChunk(group, id_publisher, page, limit) {
    try {
      let restOperation;

      if (group === "superadmin") {
        let override_publisher = id_publisher ? id_publisher : 0;
        let endpoint = id_publisher
          ? "DocumentsGatewayAPI"
          : "DocumentsCopibecGatewayAPI";

        restOperation = get({ apiName: endpoint, path: String(override_publisher), options: {
          queryParams: await this.addQueryParameters(
            { hash: await this.getHash(id_publisher) },
            page,
            limit
          )
        } });
      } else {
        restOperation = get({ apiName: "DocumentsGatewayAPI", path: String(id_publisher), options: {
          queryParams: await this.addQueryParameters(
            { hash: await this.getHash(id_publisher) },
            page,
            limit
          )
        } });
      }

      const response = await restOperation.response;
      const data = await response.body.json();
      return data;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchDocumentsListChunk(group, id_publisher, page, limit, searchTerm) {
    try {
      let restOperation;

      if (group === "superadmin") {
        let override_publisher = id_publisher ? id_publisher : 0;
        let endpoint = id_publisher
          ? "DocumentsListGatewayAPI"
          : "DocumentsListCopibecGatewayAPI";

        restOperation = get({ apiName: endpoint, path: String(override_publisher), options: {
          queryParams: await this.addQueryParameters(
            { hash: await this.getHash(id_publisher) },
            page,
            limit,
            searchTerm
          )
        } });
      } else {
        restOperation = get({ apiName: "DocumentsListGatewayAPI", path: String(id_publisher), options: {
          queryParams: await this.addQueryParameters(
            { hash: await this.getHash(id_publisher) },
            page,
            limit,
            searchTerm
          )
        } });
      }

      const response = await restOperation.response;
      const data = await response.body.json();
      return data;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchPublishersChunk(group, id_publisher) {
    try {
      let response = "";
      if (group === "superadmin") {
        response = await (async () => {

          const restOp = get({ apiName: "PublishersCopibecGatewayAPI", path: String("0"), options: {
          queryParams: {
            hash: await this.getHash(id_publisher)
          }
        } });

          const resp = await restOp.response;

          return await resp.body.json();

        })();
      } else {
        response = await (async () => {

          const restOp = get({ apiName: "PublishersGatewayAPI", path: String(id_publisher), options: {
          queryParams: {
            hash: await this.getHash(id_publisher)
          }
        } });

          const resp = await restOp.response;

          return await resp.body.json();

        })();
      }
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchDocumentsDetailsChunk(id) {
    try {
      const response = await (async () => {
   const restOp = get({ apiName: "DocumentsDetailsGatewayAPI", path: String(id), options: {
        queryParams: {
          hash: await this.getHash(id)
        }
      } });
   const resp = await restOp.response;
   return await resp.body.json();
 })();

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchGroupesDocumentsDetailsChunk(id) {
    try {
      const response = await (async () => {
   const restOp = get({ apiName: "GroupesDocumentsDetailsGatewayAPI", path: String(id), options: {
        queryParams: {
          hash: await this.getHash(id)
        }
      } });
   const resp = await restOp.response;
   return await resp.body.json();
 })();
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  static async updateDocumentsDetailsChunk(data) {
    try {
      const restOp = post({
        apiName: "UpdateDocumentsDetailsGatewayAPI",
        path: "",
        options: {
          body: { ...data }
        }
      });

      const resp = await restOp.response;

      const response = await resp.body.json();
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchDemandesChunk(group, showAll, id_publisher, page, limit, searchTerm) {
    try {
      //Need to fixed this after demo
      let response = "";
      if (group === "superadmin") {
        if (showAll) {
          response = await (async () => {

            const restOp = get({ apiName: "DemandesCopibecAllGatewayAPI", path: String("0"), options: {
            queryParams: await this.addQueryParameters(
              { hash: await this.getHash(id_publisher) },
              page,
              limit,
              searchTerm
            )
          } });

            const resp = await restOp.response;

            return await resp.body.json();

          })();
        } else {
          response = await (async () => {

            const restOp = get({ apiName: "DemandesCopibecGatewayAPI", path: String("0"), options: {
            queryParams: await this.addQueryParameters(
              { hash: await this.getHash(id_publisher) },
              page,
              limit,
              searchTerm
            )
          } });

            const resp = await restOp.response;

            return await resp.body.json();

          })();
        }
      } else {
        if (showAll) {
          response = await (async () => {

            const restOp = get({ apiName: "DemandesAllGatewayAPI", path: String(id_publisher), options: {
            queryParams: await this.addQueryParameters(
              { hash: await this.getHash(id_publisher) },
              page,
              limit,
              searchTerm
            )
          } });

            const resp = await restOp.response;

            return await resp.body.json();

          })();
        } else {
          response = await (async () => {

            const restOp = get({ apiName: "DemandesGatewayAPI", path: String(id_publisher), options: {
            queryParams: await this.addQueryParameters(
              { hash: await this.getHash(id_publisher) },
              page,
              limit,
              searchTerm
            )
          } });

            const resp = await restOp.response;

            return await resp.body.json();

          })();
        }
      }
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchDemandesDetailsChunk(statut, id) {
    try {
      let response = "";

      switch (statut) {
        case "revision":
          response = await (async () => {

            const restOp = get({ apiName: "DemandesDetailsCopibecGatewayAPI", path: String(id), options: {
            queryParams: {
              hash: await this.getHash(id)
            }
          } });

            const resp = await restOp.response;

            return await resp.body.json();

          })();
          break;

        case "attente":
          response = await (async () => {

            const restOp = get({ apiName: "DemandesDetailsGatewayAPI", path: String(id), options: {
            queryParams: {
              hash: await this.getHash(id)
            }
          } });

            const resp = await restOp.response;

            return await resp.body.json();

          })();
          break;

        case "approuvee":
          response = await (async () => {

            const restOp = get({ apiName: "DemandesDetailsApprouveeGatewayAPI", path: String(id), options: {
            queryParams: {
              hash: await this.getHash(id)
            }
          } });

            const resp = await restOp.response;

            return await resp.body.json();

          })();
          break;

        default:
          response = await (async () => {

            const restOp = get({ apiName: "DemandesDetailsRefuseeGatewayAPI", path: String(id), options: {
            queryParams: {
              hash: await this.getHash(id)
            }
          } });

            const resp = await restOp.response;

            return await resp.body.json();

          })();
      }
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  //new one
  static async approuveOrRejectDemandesDetailsChunk(data) {
    try {
      const restOp = post({
        apiName: "CreateDemandesDetailsApprouveOrRejeteGatewayAPI",
        path: "",
        options: {
          body: { ...data }
        }
      });

      const resp = await restOp.response;

      const response = await resp.body.json();

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchDemandesDetailsDocumentsChunk(isbn) {
    try {
      const restOp = get({ apiName: "DemandesDetailsDocumentsGatewayAPI", path: String(97827) });
      const resp = await restOp.response;
      const response = await resp.body.json();

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async createDemandesDetailsChunk(data) {
    try {
      const restOp = post({
        apiName: "CreateDemandesDetailsGatewayAPI",
        path: "",
        options: {
          body: { ...data }
        }
      });


      const resp = await restOp.response;


      const response = await resp.body.json();

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchDocumentsAchetesUtilisateursChunk(group, id_publisher, page, limit, searchTerm) {
    try {
      let response = "";

      if (group === "superadmin") {
        response = await (async () => {

          const restOp = get({ apiName: 
          "DocumentsCopibecAchetesUtilisateursGatewayAPI", path: String("0"), options: {
            queryParams: await this.addQueryParameters(
              { hash: await this.getHash(id_publisher) },
              page,
              limit,
              searchTerm
            )
          } });

          const resp = await restOp.response;

          return await resp.body.json();

        })();
      } else {
        response = await (async () => {

          const restOp = get({ apiName: 
          "DocumentsAchetesUtilisateursGatewayAPI", path: String(id_publisher), options: {
            queryParams: await this.addQueryParameters(
              { hash: await this.getHash(id_publisher) },
              page,
              limit,
              searchTerm
            )
          } });

          const resp = await restOp.response;

          return await resp.body.json();

        })();
      }

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchDocumentsAchetesUtilisateursDetailsChunk(id) {
    try {
      const response = await (async () => {
   const restOp = get({ apiName: 
        "DocumentsAchetesUtilisateursDetailsGatewayAPI", path: String(id), options: {
          queryParams: {
            hash: await this.getHash(id)
          }
        } });
   const resp = await restOp.response;
   return await resp.body.json();
 })();

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchCommandesAchatsChunk(group, id_publisher, page, limit, searchTerm) {
    try {
      let response = "";

      if (group === "superadmin") {
        response = await (async () => {

          const restOp = get({ apiName: "CommandesCopibecAchatsGatewayAPI", path: String("0"), options: {
          queryParams: await this.addQueryParameters(
            { hash: await this.getHash(id_publisher) },
            page,
            limit,
            searchTerm
          )
        } });

          const resp = await restOp.response;

          return await resp.body.json();

        })();
      } else {
        response = await (async () => {

          const restOp = get({ apiName: "CommandesAchatsGatewayAPI", path: String(id_publisher), options: {
          queryParams: await this.addQueryParameters(
            { hash: await this.getHash(id_publisher) },
            page,
            limit,
            searchTerm
          )
        } });

          const resp = await restOp.response;

          return await resp.body.json();

        })();
      }

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchCommandesAchatsDocumentsDetailsChunk(id) {
    try {
      const response = await (async () => {
   const restOp = get({ apiName: 
        "CommandesAchatsDocumentsDetailsGatewayAPI", path: String(id), options: {
          queryParams: {
            hash: await this.getHash(id)
          }
        } });
   const resp = await restOp.response;
   return await resp.body.json();
 })();

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  ///check id for this function

  static async fetchCommandesAchatsOrderDetailsChunk(id) {
    try {
      const response = await (async () => {
   const restOp = get({ apiName: "CommandesAchatsOrderDetailsGatewayAPI", path: String(id), options: {
        queryParams: {
          hash: await this.getHash(id)
        }
      } });
   const resp = await restOp.response;
   return await resp.body.json();
 })();

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async approveOrRefuseCommandesAchatsOrderDetailsChunk(data) {
    try {
      const restOp = post({
        apiName: "ApproveOrRefuseCommandesAchatsOrderDetailsGatewayAPI",
        path: "",
        options: {
          body: { ...data }
        }
      });


      const resp = await restOp.response;


      const response = await resp.body.json();

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchHistoriquesRepresentantsChunk(group, id_publisher, page, limit, searchTerm) {
    try {
      let response = "";

      if (group === "superadmin") {
        response = await (async () => {

          const restOp = get({ apiName: "HistoriquesCopibecRepresentantsGatewayAPI", path: String("0"), options: {
          queryParams: await this.addQueryParameters(
            { hash: await this.getHash(id_publisher) },
            page,
            limit,
            searchTerm
          )
        } });

          const resp = await restOp.response;

          return await resp.body.json();

        })();
      } else {
        response = await (async () => {

          const restOp = get({ apiName: "HistoriquesRepresentantsGatewayAPI", path: String(id_publisher), options: {
          queryParams: await this.addQueryParameters(
            { hash: await this.getHash(id_publisher) },
            page,
            limit,
            searchTerm
          )
        } });

          const resp = await restOp.response;

          return await resp.body.json();

        })();
      }
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchHistoriquesRepresentantsOrderDetailsChunk(id) {
    try {
      const response = await (async () => {
   const restOp = get({ apiName: 
        "HistoriquesRepresentantsOrderDetailsGatewayAPI", path: String(id), options: {
          queryParams: {
            hash: await this.getHash(id)
          }
        } });
   const resp = await restOp.response;
   return await resp.body.json();
 })();

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchHistoriquesRepresentantsDocumentsDetailsChunk(id) {
    try {
      const response = await (async () => {
   const restOp = get({ apiName: 
        "HistoriquesRepresentantsDocumentsDetailsGatewayAPI", path: String(id), options: {
          queryParams: {
            hash: await this.getHash(id)
          }
        } });
   const resp = await restOp.response;
   return await resp.body.json();
 })();
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async postPublicationChunk(data) {
    try {
      const restOp = post({
        apiName: "PublicationGatewayAPI",
        path: "",
        options: {
          body: { ...data }
        }
      });


      const resp = await restOp.response;


      const response = await resp.body.json();

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async S3DeleteChunk(file) {
    try {
      const response = await remove({ path: file, options: { accessLevel: "protected" } });

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async S3GetChunk(file) {
    try {
      const response = await getUrl({ path: file, options: { accessLevel: "protected" } });

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchOffresGroupesChunk(group, id_publisher, page, limit, searchTerm) {
    try {
      let response = "";

      if (group === "superadmin") {
        response = await (async () => {

          const restOp = get({ apiName: "OffresGroupesCopibecGatewayAPI", path: String("0"), options: {
          queryParams: await this.addQueryParameters(
            { hash: await this.getHash(id_publisher) },
            page,
            limit,
            searchTerm
          )
        } });

          const resp = await restOp.response;

          return await resp.body.json();

        })();
      } else {
        response = await (async () => {

          const restOp = get({ apiName: "OffresGroupesGatewayAPI", path: String(id_publisher), options: {
          queryParams: await this.addQueryParameters(
            { hash: await this.getHash(id_publisher) },
            page,
            limit,
            searchTerm
          )
        } });

          const resp = await restOp.response;

          return await resp.body.json();

        })();
      }

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchDocumentDetailsOffresGroupesChunk(id) {
    try {
      const response = await (async () => {
   const restOp = get({ apiName: "DocumentDetailsOffresGroupesGatewayAPI", path: String(id), options: {
        queryParams: {
          hash: await this.getHash(id)
        }
      } });
   const resp = await restOp.response;
   return await resp.body.json();
 })();

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async createDocumentDetailsOffresGroupesChunk(data) {
    try {
      const restOp = post({
        apiName: "CreateDocumentDetailsGroupesGatewayAPI",
        path: "",
        options: {
          body: { ...data }
        }
      });


      const resp = await restOp.response;


      const response = await resp.body.json();

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async updateDocumentDetailsOffresGroupesChunk(data) {
    try {
      const restOp = post({
        apiName: "UpdateDocumentDetailsGroupesGatewayAPI",
        path: "",
        options: {
          body: { ...data }
        }
      });


      const resp = await restOp.response;


      const response = await resp.body.json();

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchComboOffresGroupesChunk(group, id_publisher) {
    try {
      let response = "";

      if (group === "superadmin") {
        response = await (async () => {

          const restOp = get({ apiName: "ComboCopibecOffresGroupesGatewayAPI", path: String(0), options: {
          queryParams: {
            hash: await this.getHash(id_publisher)
          }
        } });

          const resp = await restOp.response;

          return await resp.body.json();

        })();
      } else {
        const restOp = get({ apiName: "ComboOffresGroupesGatewayAPI", path: String(id_publisher), options: {
          queryParams: {
            hash: await this.getHash(id_publisher)
          }
        } });
        const resp = await restOp.response;
        response = await resp.body.json();
      }

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchDocumentsGroupesChunk(id) {
    try {
      const response = await (async () => {
   const restOp = get({ apiName: "DocumentsGroupesGatewayAPI", path: String(id), options: {
        queryParams: {
          hash: await this.getHash(id)
        }
      } });
   const resp = await restOp.response;
   return await resp.body.json();
 })();

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchRaisonsChunk(group, id_publisher) {
    try {
      let response = "";
      if (group === "superadmin") {
        response = await (async () => {

          const restOp = get({ apiName: "RaisonsSuperAdminGatewayAPI", path: String(""), options: {
          queryParams: {
            hash: await this.getHash(id_publisher)
          }
        } });

          const resp = await restOp.response;

          return await resp.body.json();

        })();
      } else {
        response = await (async () => {

          const restOp = get({ apiName: "RaisonsAdminGatewayAPI", path: String(""), options: {
          queryParams: {
            hash: await this.getHash(id_publisher)
          }
        } });

          const resp = await restOp.response;

          return await resp.body.json();

        })();
      }
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async fetchOrderProductsChunk(orderId) {
    try {
      const restOp = get({
        apiName: "OrderProductsGatewayAPI",
        path: String(orderId),
        options: {
          queryParams: {
            hash: await this.getHash(orderId)
          }
        }
      });

      const resp = await restOp.response;

      const response = await resp.body.json();

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  static async resetOrderDownloadsChunk(data) {
    try {
      const restOp = post({
        apiName: "ResetOrderDownloadsGatewayAPI",
        path: "",
        options: {
          body: { values: { ...data } }
        }
      });

      const resp = await restOp.response;

      const response = await resp.body.json();

      return response;
    } catch (error) {
      console.error(error);
    }
  }
}
